<template>
  <v-flex xsm12>
    <exposure-drilldown
      :reportParameters="lastParams"
      :value="drilldownOpen"
      @input="drilldownOpen = $event"
    />
    <page-toolbar>
      <exposure-toolbar @change="toolbarChange"> </exposure-toolbar>
      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
      <kendo-button
        type="button"
        @click="showChart()"
        title="Open Chart"
        style="display:inline-block"
      >
        <v-icon small>bar_chart</v-icon>
      </kendo-button>
      <kendo-button icon="pdf" title="Export to Pdf" @click="exportToPdf"> </kendo-button>
    </page-toolbar>
    <div ref="container" class="exposureGrid"></div>
    <v-dialog v-model="chartDialog" width="830" height="420">
      <v-card>
        <v-responsive height="420">
          <div class="chart" ref="marketDataChart" />
          <v-progress-linear :indeterminate="true" v-if="chartLoading"></v-progress-linear>
        </v-responsive>
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<script>
import ExposureToolbar from '@/components/Clients/Heroux/ExposureToolbar'
import PageToolbar from '@/components/PageToolbar'
import exposureGrid from '@/dashboard-components/heroux-exposure-grid'
import ExposureDrilldown from '@/components/Clients/Heroux/ExposureDrilldown'
import exposureChart from '@/dashboard-components/heroux-exposure-chart'
import dashboardService from '@/services/dashboard'
import {getDataItem} from '@/helpers/kendo-helpers'
import {mapGetters} from 'vuex'
import axios from 'axios'
const $ = kendo.jQuery
export default {
  mounted() {
    this.$el.addEventListener('click', this.drilldownClick, false)
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  components: {
    ExposureToolbar,
    PageToolbar,
    ExposureDrilldown,
  },
  data() {
    return {
      selectedValues: null,
      chartDialog: false,
      chartLoading: false,
      lastParams: null,
      drilldownOpen: false,
    }
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
    this.$el.removeEventListener('click', this.drilldownClick)
  },
  methods: {
    setGridLoading(status) {
      const container = $(this.$refs.container)
      kendo.ui.progress(container, status)
      this.showPdfProgress = status
    },
    async exportToPdf() {
      const {data, error} = await axios.get('/api/heroux/ExposureReport/getManualDashboardId', {
        params: {
          clientId: this.clientId,
        },
      })
      if (error) {
        throw error
      }

      const {dashboardId} = data
      this.setGridLoading(true)

      dashboardService
        .loadIframe(dashboardId, this.selectedValues.asOfDate, ({name, message, progress}) => {
          if (message) {
            this.pdfMessage = message
          }

          if (name == 'rendering') {
            this.pdfProgress = progress
          }
        })
        .catch(() => {
          this.setGridLoading(false)
        })
        .then(() => this.setGridLoading(false))

      return false
    },
    drilldownClick({target}) {
      if (!/adjustmentDrillDown|hedge\w+DrillDown/.test(target.className)) return

      const dataItem = getDataItem(target)

      const fromDate = kendo.toString(dataItem.PeriodStart, 's')
      const toDate = kendo.toString(dataItem.PeriodEnd, 's')
      const {className} = target
      const columnType = className.includes('adjustmentDrillDown')
        ? 3
        : className.includes('hedgeCDrillDown')
        ? 1
        : 2

      const drilldownParams = {fromDate, toDate, columnType}
      this.lastParams = {...this.lastParams, ...drilldownParams}
      this.drilldownOpen = true
    },
    async showChart() {
      const params = this.selectedValues
      kendo.destroy(this.$refs.marketDataChart)
      kendo.jQuery(this.$refs.marketDataChart).empty()
      this.chartDialog = true
      this.chartLoading = true
      await exposureChart.render(this.$refs.marketDataChart, params, 'report')
      this.chartLoading = false
    },
    toolbarChange(e) {
      this.selectedValues = e
      exposureGrid.render(kendo.jQuery(this.$refs.container), e, 'report')
      this.lastParams = e
    },
    exportToExcel() {
      window.location.href = `/api/heroux/ExposureReport/exportExposureReport?clientId=${
        this.selectedValues.clientId
      }
      &periodId=${this.selectedValues.periodId}&divisionId=${
        this.selectedValues.divisionId
      }&ccyPairId=${this.selectedValues.ccyPairId}
      &fromDate=${this.selectedValues.fromDate}&toDate=${this.selectedValues.toDate}&quarterView=${
        this.selectedValues.quarterView
      }&t=${this.tokenString}`
    },
  },
}
</script>

<style scoped>
.exposureGrid {
  font-size: 0.9em;
}
.chart {
  overflow: hidden;
}
</style>
<style>
.hedgeCDrillDown,
.hedgeNCDrillDown,
.adjustmentDrillDown {
  text-decoration: underline;
}

.hedgeCDrillDown:hover,
.hedgeNCDrillDown:hover,
.adjustmentDrillDown:hover {
  cursor: pointer;
}
</style>
